import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SettingsService} from '../core/settings.service';
import {Cookie} from '../helper/cookie';

@Injectable()
export class PricingService {
  constructor(
    private httpClient: HttpClient,
    private settingsService: SettingsService
  ) {}

  getPricing(parameters: any) {
    const cookies = new Cookie();
    const refCode = cookies.getCookie('ref_code');
    if (parameters === undefined) {
      parameters = {};
    }

    const params = {
      smart: '1'
    };

    if (refCode !== undefined) {
      params['refCode'] = refCode;
    }

    if (parameters.type !== undefined) {
      params['type'] = parameters.type;
    }

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'pricing',
      {
        params: params
      }
    );
  }

  getPricingTime(parameters: any) {
    const cookies = new Cookie();
    const refCode = cookies.getCookie('ref_code');
    if (parameters === undefined) {
      parameters = {};
    }

    const params = {

    };

    if (refCode !== undefined) {
      params['refCode'] = refCode;
    }

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'pricing/time',
      {
        params: params
      }
    );
  }

  getPrice(id: number) {
    const cookies = new Cookie();
    const refCode = cookies.getCookie('ref_code');

    const params = {};
    if (refCode !== undefined) {
      params['refCode'] = refCode;
    }

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'prices/' + id,
      {
        params: params
      }
    );
  }

  getPriceProfile(id: number) {
    const cookies = new Cookie();
    const refCode = cookies.getCookie('ref_code');

    const params = {};
    if (refCode !== undefined) {
      params['refCode'] = refCode;
    }

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'prices/' + id.toString() + '/profile',
      {
        params: params
      }
    );
  }
}
